exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-expansion-panel-content span a{color:#fff}.v-expansion-panel-content span a:hover{color:#b3b3b3}", ""]);

// exports
